export const MinimizedView = {
    Bar: 1,
    Icon: 2
};

export const WidgetPosition = {
    Left: 1,
    Right: 2
};
